import hmMenuToggles from './menuToggles.hm'
import monkiMenuToggles from './menuToggles.monki'

const menuToggles = process.env.BRAND_PREFIX === 'monki' ? monkiMenuToggles : hmMenuToggles

export default menuToggles
